import type { SellerNewOrderNotificationData } from './types'
import { normalizeSellerNewOrderNotificationsPayload } from '@/resources/utils/orders/notification'
import { QueryOptions } from '@/resources/types'
import { gql } from 'graphql-request'
import { useQuery } from '@/proxy/react-query'
import { client } from '@/proxy/client'

export const SELLER_NEW_ORDER_NOTIFICATION_QUERY_KEY =
  'sellerNewOrderNotification'

const SELLER_NEW_ORDER_NOTIFICATION = gql`
  query sellerNewOrderNotification {
    newOrderNotifications {
      orderNumber
      deliveryType
    }
  }
`

export const useSellerNewOrderNotification = (options: QueryOptions = {}) =>
  useQuery<SellerNewOrderNotificationData>({
    queryKey: [SELLER_NEW_ORDER_NOTIFICATION_QUERY_KEY],
    queryFn: async ({ signal }) => {
      const raw = await client.request<unknown>({
        document: SELLER_NEW_ORDER_NOTIFICATION,
        signal,
      })
      return {
        newOrderNotifications: normalizeSellerNewOrderNotificationsPayload(raw),
      }
    },
    gcTime: 0,
    ...options,
    enabled: false,
    refetchInterval: false,
  })

export type {
  SellerNewOrderNotificationData,
  SellerNewOrderNotificationItem,
} from './types'
